module.exports = __webpack_public_path__ + "img/5.c30fcd56.jpeg";